
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/editor-console/content/widget/referanceEditor",
      function () {
        return require("private-next-pages/admin/editor-console/content/widget/referanceEditor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/editor-console/content/widget/referanceEditor"])
      });
    }
  